let cleanup = () => {};

document.addEventListener("turbo:load", () => {
  cleanup();

  const viewport = document.querySelector("[data-host-offers-scroll]");
  const navigation = document.querySelector("[data-host-offers-scroll-nav]");
  if (!viewport || !navigation) return;

  const buttons = navigation.querySelectorAll("button");
  const update = () => {
    const maximum = viewport.scrollWidth - viewport.clientWidth;
    navigation.classList.toggle("hidden", maximum <= 1);
    buttons.forEach((button) => {
      const atEdge = button.dataset.hostOffersScrollDirection === "left"
        ? viewport.scrollLeft <= 1
        : viewport.scrollLeft >= maximum - 1;
      button.disabled = atEdge;
      button.classList.toggle("invisible", atEdge);
    });
  };

  const scroll = (event) => {
    const button = event.target.closest("[data-host-offers-scroll-direction]");
    if (!button) return;

    viewport.scrollBy({
      left: viewport.clientWidth * 0.8 * (button.dataset.hostOffersScrollDirection === "left" ? -1 : 1),
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth",
    });
  };

  const observer = new ResizeObserver(update);
  observer.observe(viewport);
  observer.observe(viewport.querySelector("table"));
  viewport.addEventListener("scroll", update, { passive: true });
  navigation.addEventListener("click", scroll);
  update();

  cleanup = () => {
    observer.disconnect();
    viewport.removeEventListener("scroll", update);
    navigation.removeEventListener("click", scroll);
    cleanup = () => {};
  };
});

document.addEventListener("turbo:before-cache", () => cleanup());
